import React, { Component } from 'react';
import ReactGA from 'react-ga';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactDOM from 'react-dom';
import store from './store';
import moment from 'moment';

import Header from './components/Header';
import Footer from './components/Footer';
import Lightbox from './components/Lightbox';
import Routes from './routes';
import OnRouteChange from './components/utility/OnRouteChange';
import Amplify, { Auth } from 'aws-amplify';
import AmplifyHub from './components/Auth/AmplifyHub';
import './i18n';
import i18n from 'i18next';
import { lotamePixel } from './js/utility';

import { completeSignIn } from './actions/auth';

import TagManager from 'react-gtm-module';
import FacebookPixel from 'react-facebook-pixel';
import { Helmet } from 'react-helmet';

// Google Analytics Setup
ReactGA.initialize(process.env.GA_TRACKING_ID, {
  debug: false
});

ReactGA.plugin.require('ec'); // Import Enhanced Ecommerce plugin
ReactGA.pageview(window.location.pathname + window.location.search);

// Amplify Setup
Amplify.configure({
  Auth: {
    region: process.env.AWS_COGNITO_REGION,
    identityPoolId: process.env.AWS_COGNITO_IDENTITY_POOL_ID,
    userPoolId: process.env.AWS_COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.AWS_COGNITO_CLIENT_ID,
    oauth: {
      domain: process.env.AWS_COGNITO_OAUTH_DOMAIN,
      scope: ['phone', 'email', 'openid', 'aws.cognito.signin.user.admin'],
      redirectSignIn: process.env.AWS_COGNITO_OAUTH_REDIRECT_SIGNIN,
      redirectSignOut: process.env.AWS_COGNITO_OAUTH_REDIRECT_SIGNOUT,
      responseType: 'code'
    },
    cookieStorage: {
      domain: '.' + process.env.DOMAIN_NAME,
      path: '/',
      secure: true
    },
  }
});

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedAuth: false
    };
    this.init = this.init.bind(this);
    moment.locale(i18n.language);
  }

  componentDidMount() {
    // Google Tag Manager
    const tagManagerArgs = {
      dataLayer: {
        page: '/getaways'
      },
      gtmId: process.env.GTM_ID,

    };
    TagManager.initialize(tagManagerArgs);

    //Facebook Pixel
    const options = {
      autoConfig: true, // set pixel's autoConfig
      // debug: false, // enable logs
    };
    FacebookPixel.init('857624768814499', undefined, options);
    FacebookPixel.pageView();

    // Call Lotame pixel first time app loads
    lotamePixel();
    this._isMounted = true;
    this.init();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  async init() {
    await Auth.currentAuthenticatedUser()
      .then(user => store.dispatch(completeSignIn(user)))
      .catch(() => null);
    if (this._isMounted) {
      this.setState({
        checkedAuth: true
      });
    }
  }

  render() {
    const { checkedAuth } = this.state;
    return (
      <Provider store={store}>
        <AmplifyHub>
          <Router basename='/getaways'>
            <OnRouteChange>
              <Helmet>
                <meta
                  name='viewport'
                  content="width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0"
                />
              </Helmet>
              <Lightbox />
              <Header />
              {checkedAuth ? <Routes /> : null}
              <Footer />
            </OnRouteChange>
          </Router>
        </AmplifyHub>
      </Provider>
    );
  }
}

ReactDOM.render(<App />, document.getElementById('app'));
